// extracted by mini-css-extract-plugin
module.exports = {"visual":"visual_visual__31YCC"};